
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Home = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g stroke="none" fill="none" className="fe_c_icon__icon fe_c_icon__icon--primary">
          <path d="M10.4961832,22.7694891 C10.4961832,23.2723504 10.1014419,23.68 9.61450382,23.68 L2.88167939,23.68 C2.39474131,23.68 2,23.2723504 2,22.7694891 L2,10.850073 C2,10.5916285 2.10635288,10.3453603 2.29254274,10.1726681 L11.9308232,1.23310606 C12.2664417,0.921817921 12.7754533,0.922360329 13.110449,1.23436308 L22.7088097,10.1739251 C22.8941833,10.3465753 23,10.5922831 23,10.850073 L23,21.9417518 C23,22.9017598 22.246403,23.68 21.3167939,23.68 L15.3854962,23.68 C14.8985581,23.68 14.5038168,23.2723504 14.5038168,22.7694891 L14.5038168,16.7270073 L10.4961832,16.7270073 L10.4961832,22.7694891 Z M21.32,22 L21.32,11.5339434 L12.5,3.3232089 L3.68,11.5350546 L3.68,22 L8.69688073,22 L8.69688073,16.0361008 C8.69688073,15.5397792 9.09538838,15.137431 9.58697248,15.137431 L15.4130275,15.137431 C15.9046116,15.137431 16.3031193,15.5397792 16.3031193,16.0361008 L16.3031193,22 L21.32,22 Z"></path>
        </g>
      </g>
    </IconBase>);
};

Home.defaultProps = {
  title: 'Home',
};

export default Home;
